const styles = theme => ({
  textField: {
    width: '100%'
  },
  root: {
    margin: 0
  },
  formHelperTextRoot: {
    marginTop: theme.spacing.unit * 0.375,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: theme.spacing.unit * 2,
    fontFamily: theme.typography.font.main,
    fontSize: '12px',
    letterSpacing: '0.1px',
    lineHeight: '16px',
    minHeight: '16px'
  },
  label: {
    color: 'rgba(12,31,44,0.6)'
  },
  inputBaseRoot: {
    paddingTop: theme.spacing.unit * 2.25,
    paddingRight: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2.25,
    paddingLeft: theme.spacing.unit * 2
  },
  inputBaseRootWidthEndAddorment: {
    paddingTop: theme.spacing.unit * 2.25,
    paddingRight: 0,
    paddingBottom: theme.spacing.unit * 2.25,
    paddingLeft: theme.spacing.unit * 2
  },
  inputBaseRootWidthStartAdornment: {
    paddingTop: theme.spacing.unit * 2.25,
    paddingRight: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2.25,
    paddingLeft: theme.spacing.unit * 0.5
  },
  closeIcon: {
    color: 'rgba(12,31,44,0.54)',
    cursor: 'pointer',
    marginRight: theme.spacing.unit * 0.25
  }
});

export default styles;
